import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import EditLocation from '@material-ui/icons/EditLocation';

class AddressContextMenu extends Component {
  constructor(props) {
    super(props);
    this.onGeocorrect = this.onGeocorrect.bind(this);
  }

  onGeocorrect() {
    this.props.onClose();
    const { publicEditing: { hash } = {} } = this.props.address;
    if (hash !== undefined) {
      window.open(`https://geo-correction.gls-spain.es/editExpeditionByHash/${hash}`, '_blank');
    }
  }

  render() {
    const { t, x, y, onClose } = this.props;
    const open = x !== undefined && y !== undefined;
    const position = { left: x || 0, top: y || 0 };
    return (
      <React.Fragment>
        <Menu id="address-menu" open={open} anchorReference="anchorPosition" anchorPosition={position} onClose={onClose}>
          <MenuItem dense disableGutters onClick={this.onGeocorrect}>
            <ListItemIcon>
              <EditLocation/>
            </ListItemIcon>
            <ListItemText primary={t('buttons.editLocation')} secondary={t('messages.opensInAnotherWindow')}/>
          </MenuItem>
        </Menu>
      </React.Fragment>
    );
  }
}

AddressContextMenu.propTypes = {
  t: PropTypes.func.isRequired,
  x: PropTypes.number,
  y: PropTypes.number,
  address: PropTypes.object,
  onClose: PropTypes.func.isRequired,
};

export default withNamespaces()(AddressContextMenu);



// WEBPACK FOOTER //
// ./src/components/AddressContextMenu.js